import { Component } from '@angular/core';

@Component({
  selector: 'internal-access-layout',
  templateUrl: './internal-access-layout.component.html',
  styleUrl: './internal-access-layout.component.scss',
  standalone: false,
})
export class InternalAccessLayoutComponent {}
